import {
    SparklesIcon,
    CubeIcon,
    SquaresPlusIcon,
    CircleStackIcon,
    ShoppingBagIcon,
    BuildingOffice2Icon,
    Cog6ToothIcon,
    ChatBubbleLeftEllipsisIcon,
    PaperClipIcon,
    PlusIcon,
    ArrowUturnLeftIcon,
    ArrowUturnRightIcon,
    H1Icon,
    H2Icon,
    H3Icon,
    ListBulletIcon,
    NumberedListIcon,
    TableCellsIcon,
    BoldIcon,
    ItalicIcon,
    UnderlineIcon,
    StrikethroughIcon,
    LinkIcon,
    ArrowTurnDownLeftIcon,
    AdjustmentsHorizontalIcon,
    SwatchIcon,
    WrenchScrewdriverIcon,
    QueueListIcon,
    CalendarDaysIcon,
    BoltIcon,
} from "@heroicons/react/24/solid";

import {
    CodeBracketSquareIcon,
    CodeBracketIcon,
    DocumentTextIcon,
    PhotoIcon,
    SunIcon,
    MoonIcon,
    MinusIcon,
    ChevronDownIcon,
} from "@heroicons/react/24/outline";
// } from "@heroicons/react/24/outline";

export const getHeroIcon = (name, style) => {
    switch (name) {
        case "sparkles":
            return <SparklesIcon style={style} />;
        case "calendar":
            return <CalendarDaysIcon style={style} />;
        case "adjustment-horizontal":
            return <AdjustmentsHorizontalIcon style={style} />;
        case "cube":
            return <CubeIcon style={style} />;
        case "circle-stack":
            return <CircleStackIcon style={style} />;
        case "swatch":
            return <SwatchIcon style={style} />;
        case "wrench-screwdriver":
            return <WrenchScrewdriverIcon style={style} />;
        case "queue":
            return <QueueListIcon style={style} />;
        case "shopping-bag":
            return <ShoppingBagIcon style={style} />;
        case "building-office-2":
            return <BuildingOffice2Icon style={style} />;
        case "cog-6-tooth":
            return <Cog6ToothIcon style={style} />;
        case "chat-bubble-left-ellipsis":
            return <ChatBubbleLeftEllipsisIcon style={style} />;
        case "squares-plus":
            return <SquaresPlusIcon style={style} />;
        case "plus":
            return <PlusIcon style={style} />;
        case "paperclip":
            return <PaperClipIcon style={style} />;
        case "arrow-uturn-down-left":
            return <ArrowUturnLeftIcon style={style} />;
        case "arrow-uturn-down-right":
            return <ArrowUturnRightIcon style={style} />;
        case "code-bracket":
            return <CodeBracketIcon style={style} />;
        case "code-bracket-square":
            return <CodeBracketSquareIcon style={style} />;
        case "H1":
            return <H1Icon style={style} />;
        case "H2":
            return <H2Icon style={style} />;
        case "H3":
            return <H3Icon style={style} />;
        case "list-bullet":
            return <ListBulletIcon style={style} />;
        case "numbered-bullet":
            return <NumberedListIcon style={style} />;
        case "table":
            return <TableCellsIcon style={style} />;
        case "bold":
            return <BoldIcon style={style} />;
        case "italic":
            return <ItalicIcon style={style} />;
        case "underline":
            return <UnderlineIcon style={style} />;
        case "strikethrough":
            return <StrikethroughIcon style={style} />;
        case "link":
            return <LinkIcon style={style} />;
        case "document-text":
            return <DocumentTextIcon style={style} />;
        case "sun":
            return <SunIcon style={style} />;
        case "bolt":
            return <BoltIcon style={style} />;
        case "moon":
            return <MoonIcon style={style} />;
        case "image":
            return <PhotoIcon style={style} />;
        case "minus":
            return <MinusIcon style={style} />;
        case "chevron-down":
            return <ChevronDownIcon style={style} />;
        case "arrow-turn-down-left":
            return <ArrowTurnDownLeftIcon style={style} />;
        case "photo":
            return <PhotoIcon style={style} />;
        case "cube":
            return <CubeIcon style={style} />;
        case "document-text":
            return <DocumentTextIcon style={style} />;
        case "chevron-down":
            return <ChevronDownIcon style={style} />;
        default:
            <p>NF</p>;
    }
};
